import {
  FloatingPortal,
  useMergeRefs,
  useTransitionStyles,
  type UseTransitionStylesProps,
} from "@floating-ui/react";
import { forwardRef, type HTMLProps } from "react";
import { twMerge } from "tailwind-merge";
import { useTooltipContext } from "./TooltipContext";
import { useFloatingLayer } from "../../floatingLayerContext";

interface TooltipContentProps extends HTMLProps<HTMLDivElement> {
  transition?: UseTransitionStylesProps;
}

export const TooltipContent = forwardRef<HTMLDivElement, TooltipContentProps>(
  ({ transition, ...props }, propRef) => {
    const context = useTooltipContext();
    const { tooltip } = useFloatingLayer();
    const ref = useMergeRefs([context.refs.setFloating, propRef]);
    const { isMounted, styles } = useTransitionStyles(
      context.context,
      transition,
    );
    const shouldRender = transition ? isMounted : context.open;

    return (
      <FloatingPortal>
        {shouldRender && (
          <div
            ref={ref}
            style={{
              position: context.strategy,
              top: context.y,
              left: context.x,
              visibility: context.x == null ? "hidden" : "visible",
              ...(transition ? styles : {}),
              ...props.style,
            }}
            className={twMerge(
              `${tooltip} rounded-sm p-1 text-sm text-white`,
              props.className,
            )}
            {...context.getFloatingProps(props)}
          />
        )}
      </FloatingPortal>
    );
  },
);

TooltipContent.displayName = "TooltipContent";
